import React from 'react';
import { Grid, Box, Typography, Button } from '@mui/material';

const FaucetCard = ({ name, logoUrl, logoStyle, faucetUrl, faucetLabel, metamaskConfig, walletHint, isDark, onAddToMetaMask }) => (
  <Grid item xs={12} sm={6} md={4}>
    <Box sx={{
      p: 2,
      border: `1px solid ${isDark ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.1)'}`,
      borderRadius: 2,
      bgcolor: isDark ? 'rgba(0,0,0,0.2)' : 'rgba(0,0,0,0.02)',
      '&:hover': { bgcolor: isDark ? 'rgba(0,0,0,0.3)' : 'rgba(0,0,0,0.04)' }
    }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
        <Box
          component="img"
          src={logoUrl}
          alt={name}
          sx={{ width: 24, height: 24, ...logoStyle }}
        />
        <Typography variant="subtitle1" fontWeight="bold">
          {name}
        </Typography>
      </Box>
      <Button
        variant="outlined"
        size="small"
        fullWidth
        href={faucetUrl}
        target="_blank"
        rel="noopener noreferrer"
        sx={{
          mb: 1,
          borderColor: isDark ? '#404040' : '#d4d4d4',
          color: isDark ? '#e5e5e5' : '#171717',
          '&:hover': { borderColor: isDark ? '#737373' : '#737373', bgcolor: isDark ? 'rgba(255,255,255,0.03)' : 'rgba(0,0,0,0.03)' },
        }}
      >
        {faucetLabel}
      </Button>
      {metamaskConfig ? (
        <Button
          variant="outlined"
          size="small"
          fullWidth
          onClick={() => onAddToMetaMask(metamaskConfig)}
          sx={{
            borderColor: isDark ? '#525252' : '#a3a3a3',
            color: isDark ? '#a3a3a3' : '#525252',
            '&:hover': { borderColor: isDark ? '#737373' : '#737373', bgcolor: isDark ? 'rgba(255,255,255,0.03)' : 'rgba(0,0,0,0.03)' },
          }}
        >
          Add to MetaMask
        </Button>
      ) : (
        <Button variant="outlined" size="small" fullWidth disabled sx={{ opacity: 0.5 }}>
          {walletHint || 'Use Phantom Wallet'}
        </Button>
      )}
    </Box>
  </Grid>
);

export const FAUCET_DATA = [
  {
    name: 'Ethereum Sepolia',
    logoUrl: '/logos/ethereum.png',
    faucetUrl: 'https://sepoliafaucet.com/',
    faucetLabel: 'Get Sepolia ETH',
    metamaskConfig: {
      chainId: '0xaa36a7',
      chainName: 'Sepolia',
      nativeCurrency: { name: 'Sepolia ETH', symbol: 'ETH', decimals: 18 },
      rpcUrls: ['https://rpc.sepolia.org'],
      blockExplorerUrls: ['https://sepolia.etherscan.io']
    },
  },
  {
    name: 'BNB Testnet',
    logoUrl: '/logos/bnb.png',
    faucetUrl: 'https://testnet.bnbchain.org/faucet-smart',
    faucetLabel: 'Get tBNB',
    metamaskConfig: {
      chainId: '0x61',
      chainName: 'BNB Smart Chain Testnet',
      nativeCurrency: { name: 'Test BNB', symbol: 'tBNB', decimals: 18 },
      rpcUrls: ['https://data-seed-prebsc-1-s1.bnbchain.org:8545'],
      blockExplorerUrls: ['https://testnet.bscscan.com']
    },
  },
  {
    name: 'Polygon Amoy',
    logoUrl: '/logos/polygon.png',
    faucetUrl: 'https://faucet.polygon.technology/',
    faucetLabel: 'Get MATIC',
    metamaskConfig: {
      chainId: '0x13882',
      chainName: 'Polygon Amoy Testnet',
      nativeCurrency: { name: 'MATIC', symbol: 'MATIC', decimals: 18 },
      rpcUrls: ['https://rpc-amoy.polygon.technology'],
      blockExplorerUrls: ['https://amoy.polygonscan.com']
    },
  },
  {
    name: 'Base Sepolia',
    logoUrl: '/logos/base.png',
    logoStyle: { borderRadius: '50%' },
    faucetUrl: 'https://www.alchemy.com/faucets/base-sepolia',
    faucetLabel: 'Get Base ETH',
    metamaskConfig: {
      chainId: '0x14a34',
      chainName: 'Base Sepolia',
      nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
      rpcUrls: ['https://sepolia.base.org'],
      blockExplorerUrls: ['https://sepolia.basescan.org']
    },
  },
  {
    name: 'Solana Devnet',
    logoUrl: '/logos/solana.png',
    faucetUrl: 'https://faucet.solana.com/',
    faucetLabel: 'Get SOL',
    metamaskConfig: null, // Solana uses Phantom wallet
    walletHint: 'Use Phantom Wallet',
  },
  {
    name: 'Tron Nile',
    logoUrl: '/logos/tron.svg',
    faucetUrl: 'https://nileex.io/join/getJoinPage',
    faucetLabel: 'Get TRX & USDT',
    metamaskConfig: null, // Tron uses TronLink
    walletHint: 'Use TronLink Wallet',
  },
  {
    name: 'Hyperliquid Testnet',
    logoUrl: '/logos/hyperliquid.png',
    logoStyle: { borderRadius: '50%' },
    faucetUrl: 'https://app.hyperliquid-testnet.xyz/faucet',
    faucetLabel: 'Get Test Tokens',
    metamaskConfig: {
      chainId: '0x28c5d',
      chainName: 'Hyperliquid Testnet',
      nativeCurrency: { name: 'USD', symbol: 'USD', decimals: 6 },
      rpcUrls: ['https://api.hyperliquid-testnet.xyz/evm'],
      blockExplorerUrls: ['https://explorer.hyperliquid-testnet.xyz']
    },
  },
];

export default FaucetCard;
